import * as c from '../constants';
import uuid from 'uuid/v1';


const INIT_STATE = {
  id: uuid(),
  reference_id: null,
  active: true,
  name: ""
};


export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case c.HOTKEY_TMP_RESET: {
      return INIT_STATE;
    }

    case c.HOTKEY_TMP_SET_TEMPLATE_STATE: {
      return action.payload
    }

    default: {
      return state;
    }
  }
}
